import { render } from "./Awards.vue?vue&type=template&id=99a1bd3e&scoped=true"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"

import "./Awards.vue?vue&type=style&index=0&id=99a1bd3e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a1bd3e"]])

export default __exports__